/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_Li3_PostInputs */

const tr_iade_iptal_s9_li3_post = /** @type {(inputs: Iade_Iptal_S9_Li3_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`üzerinden mesai saatleri içinde sözlü bildirim yapılabilir; yazılı teyit için Platform içi veya e-posta kanalı tamamlayıcı olarak kullanılır.`)
};

const en_iade_iptal_s9_li3_post = /** @type {(inputs: Iade_Iptal_S9_Li3_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`an oral notice may be given during business hours; for written confirmation the in-platform or email channel is used as a complement.`)
};

const de_iade_iptal_s9_li3_post = /** @type {(inputs: Iade_Iptal_S9_Li3_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kann die Beendigung innerhalb der Geschäftszeiten mündlich mitgeteilt werden; zur schriftlichen Bestätigung dient ergänzend der Kanal in der Plattform oder per E-Mail.`)
};

const ru_iade_iptal_s9_li3_post = /** @type {(inputs: Iade_Iptal_S9_Li3_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`можно подать устное уведомление в рабочее время; для письменного подтверждения дополнительно используется канал в Платформе или электронная почта.`)
};

/**
* | output |
* | --- |
* | "an oral notice may be given during business hours; for written confirmation the in-platform or email channel is used as a complement." |
*
* @param {Iade_Iptal_S9_Li3_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_li3_post = /** @type {((inputs?: Iade_Iptal_S9_Li3_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_Li3_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_li3_post(inputs)
	if (locale === "de") return de_iade_iptal_s9_li3_post(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_li3_post(inputs)
	return tr_iade_iptal_s9_li3_post(inputs)
});